<template>
  <v-layout>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <need-assistant @click="onClickAssistant($event)" />
    </v-dialog>
    <div class="btn">
      <v-snackbar
        v-model="snackbar"
        :right="x === 'right'"
        :timeout="timeout"
        color="red"
        :top="y === 'top'"
      >
        {{ errorMsg }}
        <v-btn color="black" flat @click="snackbar = false"> Close </v-btn>
      </v-snackbar>
    </div>
    <v-flex xs12 sm8 offset-sm2>
      <v-container grid-list-md>
        <v-card class="grey lighten-3">
          <v-card-title class="project">
            <div>
              <span class="headline">Project Filtering</span>
            </div>
            <div class="red--text headline ml-2">
              <v-btn
                color="white darken-1"
                small
                dark
                class="no-upercase red--text"
                @click="needAssistant"
              >
                Need assistance
              </v-btn>
            </div>
          </v-card-title>
          <v-layout row>
            <v-flex xs6>
              <v-btn v-if="allowedRespondentFilter()" @click="addGroup()">
                Add Group
              </v-btn>
              <v-btn class="btn-danger" @click="skip()"> skip </v-btn>
            </v-flex>
          </v-layout>
          <v-form
            ref="form"
            lazy-validation
            v-if="isLoadedIndex() && allowedRespondentFilter()"
          >
            <v-card
              v-for="(filter_group, index) in filteringData.add_filter_group"
              v-bind:key="index"
            >
              <v-btn class="fa-pull-right"> Group - {{ index }}</v-btn>
              <v-layout
                row
                v-for="(add_filtering, counter) in filter_group.add_filterings"
                v-bind:key="counter"
              >
                <v-flex xs3>
                  <v-select
                    v-model="
                      filteringData.add_filter_group[index].add_filterings[
                        counter
                      ].filtering_parameter_id
                    "
                    :items="indexData.datas"
                    item-text="parameter_name"
                    item-value="id"
                    box
                    label="Parameters"
                    :rules="[(v) => !!v || 'This field is required!']"
                    @change="filterOperator($event, index, counter)"
                  >
                  </v-select>
                </v-flex>
                <v-flex xs3>
                  <v-select
                    v-model="
                      filteringData.add_filter_group[index].add_filterings[
                        counter
                      ].comparison_operator_id
                    "
                    :items="
                      filteringData.add_filter_group[index].add_filterings[
                        counter
                      ].filter_operator
                    "
                    item-text="name"
                    item-value="id"
                    :rules="[(v) => !!v || 'This field is required!']"
                    box
                    @change="resetHasData()"
                    label="Conditions"
                  >
                  </v-select>
                </v-flex>
                <v-flex
                  xs3
                  v-if="
                    filteringData.add_filter_group[index].add_filterings[
                      counter
                    ].filtering_parameter_id == 1
                  "
                >
                  <v-text-field
                    v-model.lazy="
                      filteringData.add_filter_group[index].add_filterings[
                        counter
                      ].age1
                    "
                    box
                    :rules="[(v) => !!v || 'This field is required!']"
                    @keypress="resetHasData()"
                    @keydown="resetHasData()"
                    label="Age"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex
                  xs3
                  v-if="
                    (filteringData.add_filter_group[index].add_filterings[
                      counter
                    ].comparison_operator_id == 8 ||
                      filteringData.add_filter_group[index].add_filterings[
                        counter
                      ].comparison_operator_id == 9) &&
                    filteringData.add_filter_group[index].add_filterings[
                      counter
                    ].filtering_parameter_id == 1
                  "
                >
                  <v-text-field
                    v-model.lazy="
                      filteringData.add_filter_group[index].add_filterings[
                        counter
                      ].age2
                    "
                    box
                    :rules="[(v) => !!v || 'This field is required!']"
                    label="Age2"
                    @keypress="resetHasData()"
                    @keydown="resetHasData()"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex
                  xs3
                  v-if="
                    filteringData.add_filter_group[index].add_filterings[
                      counter
                    ].filtering_parameter_id == 3
                  "
                >
                  <v-select
                    v-model="
                      filteringData.add_filter_group[index].add_filterings[
                        counter
                      ].division_id
                    "
                    :rules="[(v) => !!v || 'This field is required!']"
                    :items="indexData.divisions"
                    item-text="english_title"
                    item-value="id"
                    box
                    multiple
                    label="Division"
                    @change="resetHasData()"
                  >
                  </v-select>
                </v-flex>
                <v-flex
                  xs3
                  v-if="
                    filteringData.add_filter_group[index].add_filterings[
                      counter
                    ].filtering_parameter_id == 4
                  "
                >
                  <v-select
                    v-model="
                      filteringData.add_filter_group[index].add_filterings[
                        counter
                      ].district_id
                    "
                    :rules="[(v) => !!v || 'This field is required!']"
                    :items="indexData.districts"
                    item-text="english_title"
                    item-value="id"
                    box
                    multiple
                    label="District"
                    @change="resetHasData()"
                  >
                  </v-select>
                </v-flex>
                <v-flex
                  xs3
                  v-if="
                    filteringData.add_filter_group[index].add_filterings[
                      counter
                    ].filtering_parameter_id == 2
                  "
                >
                  <v-select
                    v-model="
                      filteringData.add_filter_group[index].add_filterings[
                        counter
                      ].gender_id
                    "
                    :items="indexData.genders"
                    item-text="name"
                    item-value="id"
                    box
                    multiple
                    label="Gender"
                    :rules="[(v) => !!v || 'This field is required!']"
                    @change="resetHasData()"
                  >
                  </v-select>
                </v-flex>
                <v-flex
                  xs3
                  v-if="
                    filteringData.add_filter_group[index].add_filterings[
                      counter
                    ].filtering_parameter_id == 5
                  "
                >
                  <v-select
                    v-model="
                      filteringData.add_filter_group[index].add_filterings[
                        counter
                      ].education_id
                    "
                    :items="indexData.educations"
                    item-text="name"
                    item-value="id"
                    box
                    multiple
                    label="Educations"
                    @change="resetHasData()"
                    :rules="[(v) => !!v || 'This field is required!']"
                  >
                  </v-select>
                </v-flex>
                <v-flex
                  xs3
                  v-if="
                    filteringData.add_filter_group[index].add_filterings[
                      counter
                    ].filtering_parameter_id == 6
                  "
                >
                  <v-select
                    v-model="
                      filteringData.add_filter_group[index].add_filterings[
                        counter
                      ].profession_id
                    "
                    :items="indexData.professions"
                    item-text="name"
                    item-value="id"
                    box
                    multiple
                    label="Professions"
                    :rules="[(v) => !!v || 'This field is required!']"
                    @change="resetHasData()"
                  >
                  </v-select>
                </v-flex>
                <v-flex
                  xs3
                  v-if="
                    filteringData.add_filter_group[index].add_filterings[
                      counter
                    ].filtering_parameter_id == 7
                  "
                >
                  <v-select
                    v-model="
                      filteringData.add_filter_group[index].add_filterings[
                        counter
                      ].income_id
                    "
                    :items="indexData.income"
                    item-text="name"
                    item-value="id"
                    box
                    multiple
                    label="Income"
                    :rules="[(v) => !!v || 'This field is required!']"
                    @change="resetHasData()"
                  >
                  </v-select>
                </v-flex>

                <v-flex xs2>
                  <v-icon
                    v-if="counter != 0"
                    @click="deleteFiltering(index, counter)"
                  >
                    clear
                  </v-icon>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs6>
                  <span class="material-icons" @click="addMore(index)">
                    add_circle_outline
                  </span>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12>
                  <v-icon @click="deleteFilterGroup(index)"> clear </v-icon>
                </v-flex>
              </v-layout>
            </v-card>
          </v-form>
          <v-card-text> </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <button class="button" flat @click="back">Back</button>
            <v-btn v-if="!haveData" color="green" elevation="2" @click="check"
              >Check Available Dasher</v-btn
            >
            <v-btn color="blue" v-if="haveData">
              Available Dasher {{ checkDasher }}</v-btn
            >
            <v-btn class="button" flat @click="submit" :disabled="!haveData"
              >Save & next</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
// import router from "../../router";
import { NeedAssistant } from "@/components/index";
import utilities from "../../api/utilities.js";

export default {
  components: {
    NeedAssistant,
  },
  data: () => ({
    apiUrl: "project-filtering-param-data",
    dialog: false,
    snackbar: false,
    y: "top",
    x: "right",
    timeout: 4000,
    loader: null,
    numberOtLogics: 1,
    maxAllowedRespondentFilterLimit: 1,
    loading4: false,
    editedIndex: -1,
    total_filter_price: 0,
    filter_array: [],
    filteringData: {
      add_filter_group: [
        {
          add_filterings: [
            {
              filtering_parameter_id: "",
              comparison_operator_id: "",
              division_id: "",
              district_id: "",
              gender_id: "",
              education_id: "",
              profession_id: "",
              income_id: "",
              age1: "",
              age2: "",
              filter_operator: [],
            },
          ],
        },
      ],
      filter_skip: false,
      available_dasher: null,
      project_id: null,
    },
    defaultItem: {
      filtering_parameter_id: "",
      comparison_operator_id: "",
      value: "",
      filter_operator: [],
      filter_skip: false,
      available_dasher: null,
      project_id: null,
    },
    notChecked: true,
    haveData: false,
  }),

  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 3000);

      this.loader = null;
      // console.log(this.loader);
    },
  },

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "subscriptionData",
      "error",
      "statusCode",
      "errorMsg",
      "availableDasher",
    ]),
    checkDasher() {
      if (this.availableDasher) {
        return this.availableDasher;
      }
      return 0;
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      var project_id = JSON.parse(localStorage.getItem("project_id"));
      this.filteringData.project_id = project_id;
      this.$store.dispatch("indexData", [this.apiUrl, project_id]);
    },

    setErrorZero() {
      this.$store.dispatch("setErrorZero");
    },

    addMore(index) {
      if (this.maxAllowedRespondentFilterLimit > this.numberOtLogics) {
        this.numberOtLogics = this.numberOtLogics + 1;
        // console.log(this.numberOtLogics);
        this.haveData = false;
        this.filteringData.add_filter_group[index].add_filterings.push({
          filtering_parameter_id: "",
          comparison_operator_id: "",
          division_id: "",
          district_id: "",
          gender_id: "",
          education_id: "",
          profession_id: "",
          income_id: "",
          age1: "",
          age2: "",
          filter_operator: [],
        });
      } else {
        alert(
          "You can add maximum " + this.maxAllowedRespondentFilterLimit + " logics"
        );
      }
    },
    resetHasData(){
      this.haveData=false;
    },

    addGroup() {
      if (this.maxAllowedRespondentFilterLimit > this.numberOtLogics) {
        this.numberOtLogics = this.numberOtLogics + 1;
        this.haveData = false;
        // console.log(this.filteringData);
        this.filteringData.add_filter_group.push({
          add_filterings: [
            {
              filtering_parameter_id: "",
              comparison_operator_id: "",
              division_id: "",
              district_id: "",
              gender_id: "",
              education_id: "",
              profession_id: "",
              income_id: "",
              age1: "",
              age2: "",
              filter_operator: [],
            },
          ],
        });
      } else {
        alert(
          "You can add maximum " + this.maxAllowedRespondentFilterLimit + " logics"
        );
      }

      // console.log(this.filteringData.add_filter_group);
    },

    deleteFiltering(index, counter) {
      this.filteringData.add_filter_group[index].add_filterings.splice(
        counter,
        1
      );
      this.haveData = false;
    },
    deleteFilterGroup(index) {
      this.haveData = false;
      this.filteringData.add_filter_group.splice(index, 1);
    },
    isLoadedIndex() {
      if (this.indexData.project_data) {
        return true;
      } else {
        return false;
      }
    },
    filterOperator(event, index, counter) {
      var filterValue = [];
      if (event == 1) {
        for (let i = 0; i < this.indexData.operators.length; i++) {
          if (
            this.indexData.operators[i].id != 6 &&
            this.indexData.operators[i].id != 7
          ) {
            filterValue.push(this.indexData.operators[i]);
          }
        }
      } else {
        for (let i = 0; i < this.indexData.operators.length; i++) {
          if (
            this.indexData.operators[i].id == 6 ||
            this.indexData.operators[i].id == 7
          ) {
            filterValue.push(this.indexData.operators[i]);
          }
        }
      }

      this.filteringData.add_filter_group[index].add_filterings[
        counter
      ].filter_operator = filterValue;
    },

    close() {
      setTimeout(() => {
        this.filteringData = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    back() {
      var project_id = JSON.parse(localStorage.getItem("project_id"));
      this.$store.dispatch("indexDataAndRout", [
        "project-dasher-category",
        project_id,
        "/assign-teams-to-Project",
      ]);
    },
    skip() {
      var project_id = JSON.parse(localStorage.getItem("project_id"));
      this.filteringData.project_id = project_id;
      this.filteringData.filter_skip = true;
      this.$store.dispatch("storeOrUpdateFilterDasher", [
        "project-filtering-param-store",
        this.filteringData,
      ]);
    },
    allowedRespondentFilter() {
      this.allowedRespondentFilterLimit();
      return utilities.allowedRespondentFilter(
        this.subscriptionData.subscriptionFeatures
      );
    },
    allowedRespondentFilterLimit() {
      this.maxAllowedRespondentFilterLimit =
        utilities.allowedRespondentFilterLimit(
          this.subscriptionData.subscriptionFeatures
        );
    },
    check() {
      // console.log(this.filteringData);
      if (this.$refs.form.validate() == true) {
        this.haveData = false;
        this.$store.dispatch("checkDasher", [
          "project-dasher",
          this.filteringData,
        ]);
        this.haveData = true;
      }
    },

    needAssistant() {
      this.dialog = true;
      // this.snackbar = true;
      // this.close();
    },
    onClickAssistant(event) {
      if (event == 1) {
        this.dialog = false;
        this.snackbar = true;
        this.close;
      } else {
        this.dialog = false;
      }
    },

    submit() {
      if (this.$refs.form.validate() == true) {
        this.filteringData.available_dasher = this.availableDasher;
        this.filteringData.filter_skip = false;
        this.$store.dispatch("storeOrUpdateFilterDasher", [
          "project-filtering-param-store",
          this.filteringData,
        ]);
        this.snackbar = true;
        this.close();
      }
    },
  },
};
</script>

<style scoped>
.icon {
  background: #ff2e2e;
  color: aliceblue;
  cursor: pointer;
  border-radius: none;
  margin: 10px;
}
.delete {
  color: #3f51b5;
  cursor: pointer;
}
span {
  width: 20px;
  cursor: pointer;
}
.button {
  font-size: 16px;
  background: #ff2e2e;
  padding: 0.4rem 1.3rem;
  text-align: center;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  margin: 10px;
  color: white;
}
.headline {
  color: white;
}
.project {
  background: #ff2e2e;
}
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
.no-upercase {
  text-transform: unset !important;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
